import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { api } from "@/lib/api";
import { toast } from "sonner";

export default function AuthCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing (React StrictMode)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processSession = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get("session_id");

        if (!sessionId) {
          toast.error("Session invalide");
          navigate("/");
          return;
        }

        // Exchange session_id for user data (backend now sets JWT cookies)
        const { data: user } = await api.post("/auth/google/session", { session_id: sessionId });

        // Clear the hash from URL
        window.history.replaceState(null, "", window.location.pathname);

        // CRITICAL: Refresh auth context to sync JWT tokens with frontend state
        await refresh();

        // Navigate to dashboard
        const destination = user.role === "admin" ? "/admin" : "/mon-planning";
        navigate(destination, { replace: true });
        toast.success(`Bienvenue ${user.name} !`);

      } catch (err) {
        console.error("Auth error:", err);
        const errorMsg = err.response?.data?.detail || "Erreur de connexion";
        toast.error(errorMsg);
        navigate("/", { replace: true });
      }
    };

    processSession();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-[#F9F9F6]">
      <div className="text-center">
        <div className="mb-4 h-12 w-12 animate-spin rounded-full border-4 border-stone-200 border-t-stone-900 mx-auto"></div>
        <p className="text-sm text-stone-600">Connexion en cours...</p>
      </div>
    </div>
  );
}
